module.exports = __webpack_public_path__ + "static/media/adh1.926b14d7.jpg";